var map = {
	"./zola_registry_app_icon.png": 2023,
	"./zola_registry_app_icon@2x.png": 2024,
	"./zola_weddings_app_icon.png": 2025,
	"./zola_weddings_app_icon@2x.png": 2026,
	"./zola_weddings_app_icon_android.png": 2027,
	"./zola_weddings_app_icon_android@2x.png": 2028
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2752;



/*****************
 ** WEBPACK FOOTER
 ** ./public/images/footer nonrecursive \.(jpg|jpeg|png|gif|svg)(\?.*)?$
 ** module id = 2752
 ** module chunks = 50
 **/